export default "__VITE_ASSET__Bhj9pFx9__"